export default __webpack_public_path__ + "static/media/coachingHistory.da604d9c.svg";